<template>
  <div role="tablist">
    <b-card
      v-for="(aSection, index) in sections"
      :key="index"
      no-body
      class="mb-1"
    >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          class="d-flex"
          block
          href="#"
          v-b-toggle="`accordion-${aSection.id}`"
          variant="primary"
        >
          <b-col cols="11" class="text-left">
            {{ aSection.title }}
          </b-col>
          <b-col cols="1">
            <!-- <span v-if="true" class="fa fa-chevron-up" /> -->
            <span v-if="true" class="fa fa-chevron-down" />
          </b-col>
        </b-button>
      </b-card-header>
      <b-collapse
        :id="`accordion-${aSection.id}`"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body>
          <component
            :is="aSection.component"
            v-bind="Object.assign({}, propsData)"
            :ref="aSection.componentName"
          >
          </component>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import Notifications from "./notifications";
import Connections from "./connections";

import { mapGetters } from "vuex";

export default {
  components: {
    Notifications,
    Connections
  },
  props: {},
  methods: {
    handleSaveSectionClick(componentName) {
      // // debugger;
      this.$refs["Basics"].handleParentSave();
    },
    handleResetSectionClick(component) {}
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    propsData() {
      return {
        profile: this.profile
      };
    }
  },
  data: function() {
    return {
      sections: [
        {
          title: "Notifications",
          id: "notifications",
          component: Notifications,
          componentName: "Notifications"
        },
        {
          title: "Connections",
          id: "connections",
          component: Connections,
          componentName: "Connections"
        }
      ]
    };
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
